/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-underscore-dangle */
import { Button, CircularProgress, OutlinedInput } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './style';
import { ReactComponent as M2 } from '../../../../Asset/svg/matching2.svg';
import { useHistory } from 'react-router-dom';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { useMemo } from 'react';

interface IMatching {
  data: any;
  linkEbook?: string;
  linkResultTest?: string;
  dataFromEbook?: any;
}
const MatchingBesoinMotivation = (props: IMatching) => {
  const classes = useStyles();
  const history = useHistory();
  const { data, linkEbook, linkResultTest, dataFromEbook } = props;

  const { besoin, besoinProfil, salaire, salaireProfil } = useMemo(() => {
    return {
      besoin: data?._data?.besoin?.job || [],
      besoinProfil: data?._data?.besoin?.candidat || [],
      salaire: data?._data?.salary?.job || 'NC',
      salaireProfil: dataFromEbook?.salary ? parseInt(dataFromEbook?.salary, 10) : 'NC',
    };
  }, [data, dataFromEbook]);

  return (
    <div className={classes.containerMatch}>
      <Grid container={true} alignItems="center" justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <M2 style={{ width: 30, height: 33, marginRight: 15 }} />
          <Typography className={classes.matchTitle}>
            Matching <span>Besoins et motivation</span>
          </Typography>
        </Grid>
        <Grid item={true} lg="auto">
          {data?.isComplete && (
            <CircularProgressCustom
              value={Math.round(data?.totalPercent || 0)}
              color="#B34B4B"
              size={40}
              fontSize={12}
              fontSizeFloat={12}
              isPercent={true}
            />
          )}
        </Grid>
      </Grid>
      {/* Test des 7 besoins Needs pro® */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Test des 7 besoins Needs pro®</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            disabled={linkResultTest === ''}
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => history.push(linkResultTest as string)}>
            Accès résultats
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* Header */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopLeftRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}
        />
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Requis
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopRightRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Candidat
            </Typography>
          </div>
        </Grid>
        {/* Header */}

        {/* body */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Besoin 1
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: besoinProfil[0] !== besoin[0] ? '#E63C3C' : '' }}>
              {besoin[0] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !besoinProfil[0]
                ? classes.celluleKO
                : besoinProfil[0] === besoin[0]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!besoinProfil[0] ? (
                ''
              ) : besoinProfil[0] === besoin[0] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {besoinProfil[0] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Besoin 2
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: besoinProfil[1] !== besoin[1] ? '#E63C3C' : '' }}>
              {besoin[1] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !besoinProfil[1]
                ? classes.celluleKO
                : besoinProfil[1] === besoin[1]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!besoinProfil[1] ? (
                ''
              ) : besoinProfil[1] === besoin[1] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {besoinProfil[1] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomLeftRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Besoin 3
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderRight: '1px solid #5E65A3', borderBottom: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: besoinProfil[2] !== besoin[2] ? '#E63C3C' : '' }}>
              {besoin[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomRightRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div
            className={
              !besoinProfil[2]
                ? classes.celluleKO
                : besoinProfil[2] === besoin[2]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!besoinProfil[2] ? (
                ''
              ) : besoinProfil[2] === besoin[2] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {besoinProfil[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* Test des 7 besoins Needs pro® */}

      <div className={classes.separator} />

      {/* Autoévaluation */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Autoévaluation</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => linkEbook && history.push(linkEbook as string)}>
            Accès ebook
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* Header */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopLeftRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}
        />
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Requis
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopRightRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Candidat
            </Typography>
          </div>
        </Grid>
        {/* Header */}

        {/* body */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Montant du salaire annuel souhaité
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: salaire >= salaireProfil ? '#E63C3C' : '' }}>
              {salaire}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              salaireProfil === 'NC'
                ? classes.celluleKO
                : salaire >= salaireProfil
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {salaireProfil === 'NC' ? (
                ''
              ) : salaire >= salaireProfil ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {salaireProfil}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* Autoévaluation */}
    </div>
  );
};

export default MatchingBesoinMotivation;
